// extracted by mini-css-extract-plugin
export default {"main":"Main_main__QhrKC","welcome":"Main_welcome__cTjDO","title":"Main_title__GogqO","subtitle":"Main_subtitle__Z3btK","text":"Main_text__TjeZ1"};